// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__8Ltq_","rootSmall":"AddTileButton_rootSmall__3H1F_"};